<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" lg="6">
          <v-toolbar-title class="mb-2">Edit Informations</v-toolbar-title>
          <v-card elevation="3" class="mb-3 pt-3 pb-3">
            <v-text-field
              :rules="[rules.required, rules.maxvalue]"
              v-model="categoryDetail.categoryname"
              class="mx-3"
              label="Category Name"
              outlined
              dense
              @keyup.enter="submit"
            ></v-text-field>
            <v-text-field
              :readonly="true"
              v-model="parentCatName"
              value="Main Category"
              class="mx-3"
              label="Parint"
              outlined
              dense
              @click="dialogCategoryTree = true"
            ></v-text-field>
            <TreeCategories
              :dialogCategoryTree="dialogCategoryTree"
              v-on:closeCatDialog="closeCategory($event)"
              v-on:SendCategoryValue="insertNewCate($event)"
            />
            <v-switch
              class="mx-3"
              v-model="categoryDetail.status"
              label="Status"
              color="primary"
              hide-details
            ></v-switch>
          </v-card>
          <v-btn
            @click="submit"
            depressed
            color="primary"
            class="float-sm-right"
            :loading="loadingAdd"
          >
            Save
          </v-btn>
        </v-col>
        <v-col cols="12" lg="6">
          <v-skeleton-loader
            v-if="listLang.length == 0"
            type="article , article"
          ></v-skeleton-loader>
          <div v-else>
            <v-toolbar-title class="mb-2"
              >Category Name Translate</v-toolbar-title
            >
            <div v-for="(item, index) in listLang" :key="index">
              <v-card elevation="3" class="mb-3">
                <v-chip
                  class="ma-2 mt-3 ml-3"
                  color="green"
                  label
                  text-color="white"
                >
                  {{ item.langname }}
                </v-chip>
                <v-text-field
                  :rules="[rules.required, rules.maxvalue]"
                  class="mx-3"
                  v-model="item.langCatName"
                  label="Category Name By Trans"
                  outlined
                  dense
                  @keyup.enter="submit"
                ></v-text-field>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import TreeCategories from "@/components/Category/TreeCategories";
export default {
  props: ["item"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        maxvalue: (value) =>
          value.length <= 64 || "Maximum length is 64 characters",
      },

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Categories",
          disabled: false,
          to: "/categories",
        },
        {
          text: "Edit Category",
          disabled: true,
        },
      ],
      dialogCategoryTree: false,
      loadingAdd: false,
      listLang: [],
      parentCatName: "",
      parentCatID: null,
      categoryDetail: {
        categoryname: "",
      },
      translate: {
        categorynametrans: {},
      },
    };
  },
  components: {
    Breadcrumbs,
    TreeCategories,
  },

  mounted() {
    this.getCategoryDetail();
  },

  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        for (let index = 0; index < this.listLang.length; index++) {
          this.translate.categorynametrans[
            this.listLang[index]["langcode"]
          ] = this.listLang[index]["langCatName"];
        }
        this.loadingAdd = true;
        let DataForm = {
          Param: {
            categoryname: this.categoryDetail.categoryname,
            status: this.categoryDetail.status,
            parent_id: this.parentCatID,
            translate: this.translate,
          },
          API: "/admin/category/" + this.$route.params.categoryID,
        };
        this.$store
          .dispatch("PutToAPI", DataForm)
          .then((response) => {
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.loadingAdd = false;
            this.$router.push({ name: "Category" }).catch(() => {});
          })
          .catch(() => {
            this.loadingAdd = false;
            this.$store.dispatch("PushErrorMsg", "Validation Error");
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.listLang = response["data"]["data"];
        for (let index = 0; index < this.listLang.length; index++) {
          this.listLang[index]["langCatName"] = "";
          this.listLang[index]["langCatName"] = this.categoryDetail[
            "translate"
          ]["categorynametrans"][this.listLang[index]["langcode"]];
        }
      });
    },
    getCategoryDetail() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/category/" + this.$route.params.categoryID
        )
        .then((response) => {
          this.categoryDetail = { ...response["data"]["data"] };
          if(this.categoryDetail.parent_name == null){
            this.parentCatName = 'Root';
            this.parentCatID = null ;
          }else{
            this.parentCatName = this.categoryDetail.parent_name;
            this.parentCatID = this.categoryDetail.parent_id;
          }
          

          this.getAllLang();
        });
    },
    closeCategory(val) {
      this.dialogCategoryTree = val;
    },
    insertNewCate(val) {
      this.parentCatName = val.Name;
      this.parentCatID = val.ID;
      this.dialogCategoryTree = false;
    },
  },
};
</script>